// @ts-nocheck
import * as Types from '/ui/components/table/types';
import {yext} from '/ui/lib/msg';

const defaultProps = {
  paginationBelow: false,
  primaryActionLabel: yext.msg('Export'),
  isLoading: false,
};

/**
 * We do this rather than functional param object destructuring w/ default
 * values, This allows us to send the props object around for brevity, rather
 * than typing out all the props.
 * @param {!Types.TableProps} props
 * @returns {!Types.TableProps}
 * @suppress {checkTypes}
 */
export function getPropsWithDefaults(props) {
  return {
    ...defaultProps,
    ...props,
  };
}

/**
 * Re-exporting this here makes syntax more concise in other table files.
 * @typedef {!Types.SortDirection}
 */
export const SortDirection = Types.SortDirection;

/**
 * @typedef {!Types.CheckboxState}
 */
export const CheckboxState = Types.CheckboxState;

/**
 * Swaps the given sortDirection. NONE is turned into ASCENDING.
 * sortDirection defaults to NONE if not provided, and returns ASCENDING.
 * @param {!Types.SortDirection=} sortDirection
 * @returns {!Types.SortDirection}
 */
export function toggleSortDirection(sortDirection = SortDirection.NONE) {
  switch (sortDirection) {
    case SortDirection.ASCENDING:
    case SortDirection.DESCENDING:
      return /** @type {Types.SortDirection} */ (sortDirection * -1);
    case SortDirection.NONE:
    default:
      return SortDirection.ASCENDING;
  }
}

/**
 * Returns a new array containing the elements from dataRows sorted by
 * newSortDirection. Rows are sorted by comparing the values returned
 * from rowToValue calls.
 * @param {!Array<Types.Row>} dataRows
 * @param {!Types.SortDirection} newSortDirection
 * @param {function(!Types.Row):?} rowToValue
 * @returns {!Array<Types.Row>}
 */
export function getSortedDataRows(dataRows, newSortDirection, rowToValue) {
  return dataRows.slice().sort((rowA, rowB) => {
    const rowAVal = rowToValue(rowA);
    const rowBVal = rowToValue(rowB);
    if (rowAVal < rowBVal) {
      return /** @type {Types.SortDirection} */ (newSortDirection * 1);
    } else if (rowAVal > rowBVal) {
      return /** @type {Types.SortDirection} */ (newSortDirection * -1);
    } else {
      return 0;
    }
  });
}

/**
 * Returns a new array containing the elements from columns, with their
 * sortDirections set according to sortedColId and newSortDirection.
 * @param {!Array<Types.Column>} columns
 * @param {string} sortedColId
 * @param {!Types.SortDirection} newSortDirection
 * @returns {!Array<Types.Column>}
 */
export function getColumnsWithSortDirection(columns, sortedColId, newSortDirection) {
  return columns.map(col => {
    if (col.sortDirection === undefined) {
      return col;
    }
    if (col.id === sortedColId) {
      col.sortDirection = newSortDirection;
    } else {
      col.sortDirection = SortDirection.NONE;
    }
    return col;
  });
}

/** @enum {string} */
export const INTERNAL_COL_IDS = {
  ROW_CTA: '_rowCallToAction',
  SELECT: '_select',
};
